import React, { Component } from 'react';
import { observer } from "mobx-react";
import StatsStore from 'Stores/Stats/StatsStore';
import 'Styles/commonComponents/Table/Table.scss';

class DocumentInfoModal extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let dataItemDocment = this.props.dataItem;
        let userDlInfos = dataItemDocment.userDlInfos;
        let documentFileInfos = dataItemDocment.documentFileInfos;

        return (
            <div className="DocumentInfoModal">

                {
                    userDlInfos?.length > 0 != true ? null
                        : [
                            (
                                <div className="Stats-table-name-container">
                                    Перечень должностных лиц
                                </div>
                            ),
                            (
                                <div className="Table smr-border">
                                    <div className="header-row">
                                        <div style={{ width: "90%" }}>ДОЛЖНОСТНОЕ ЛИЦО</div>
                                        <div style={{ width: "10%" }}>ID</div>
                                    </div >
                                    <div>
                                        {
                                            userDlInfos.map(dataItem => {
                                                let userDlMainAdditionalDls = dataItem.isMain == false ? null : userDlInfos.filter(it => it.isMain == false && it.userLid == dataItem.userLid);
                                                return (
                                                    <div
                                                        key={dataItem.lid}
                                                        className='row'>
                                                        <div style={{ width: "90%" }}>
                                                            <span style={{ paddingLeft: dataItem.isMain ? null : "20px" }}>
                                                                {
                                                                    (dataItem.isMain ? "" : "(ДОП. ДЛ) ")
                                                                    +
                                                                    `${dataItem.contactName} - ${dataItem.contactPost}`
                                                                    +
                                                                    (dataItem.isMain && userDlMainAdditionalDls.length > 0 ? ` (+${userDlMainAdditionalDls.length} ДОП.ДЛ)` : "")
                                                                }
                                                            </span>
                                                        </div>
                                                        <div style={{ width: "10%" }}>
                                                            {dataItem.userLid}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        ]
                }

                {
                    documentFileInfos?.length > 0 != true ? null
                        : [
                            (
                                <div className="Stats-table-name-container">
                                    Перечень файлов
                                </div>
                            ),
                            (
                                <div className="Table smr-border">
                                    <div className="header-row">
                                        <div style={{ width: "40%" }}>Наименование файла</div>
                                        <div style={{ width: "20%" }}>Статус</div>
                                        <div style={{ width: "15%" }}>Расширение</div>
                                        <div style={{ width: "15%" }}>Размер, Мб</div>
                                        <div style={{ width: "10%" }}>ID</div>
                                    </div >
                                    <div>
                                        {
                                            documentFileInfos.map(dataItem =>
                                                <div
                                                    key={dataItem.lid}
                                                    className='row'>
                                                    <div style={{ width: "40%" }}>{dataItem.nameOnly}</div>
                                                    <div style={{ width: "20%" }}>{dataItem.isConverted ? "конвертированный" : "основной"}</div>
                                                    <div style={{ width: "15%" }}>{dataItem.extension}</div>
                                                    <div style={{ width: "15%" }}>{StatsStore.GetFileSizeMb(dataItem.size)}</div>
                                                    <div style={{ width: "10%" }}>{dataItem.lid}</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        ]
                }

            </div>
        );
    }
}

export default observer(DocumentInfoModal);